class GeoStatsList extends TableList {
  /**
   * Constructs an instance of the CampaignList class.
   */
  constructor(app, container, listRow, sortBy, sortByDirection) {
    super(app, container, listRow, false);
    if (!app.isEmpty(sortBy)) {
      this.sortBy = sortBy;
    } else {
      this.sortBy = 'dateCreated';
    }

    if (!app.isEmpty(sortByDirection)) {
      this.sortByDirection = sortByDirection;
    } else {
      this.sortByDirection = 'DESC';
    }

    this.searchParams = !app.isEmpty(window['geoSearchParams']) ? window['geoSearchParams'] : null;

    this.container.empty();
    this.paginator = new Paginator(50);
    this.renderList = this.renderList.bind(this);
    this.paginatedUrl = new PaginatedUrl(`/api/geo/visitors?view=table`, 1, 50);
    this.renderList(1);
  }

  prepareRow(row) {
    const page = _.template(this.app.templates[this.listRow]);

    const defaults = {'count': ''};
    row = {...defaults, ...row};
    
    let pageData = {
      ...row
    };

    const $page = $(page(pageData));

    return $page;
  }

  async renderList(page) {
    const self = this;
    const $listContainer = this.container
    let geoData = [];
    this.isRendering = true;

    if (this.app.isEmpty(window.allGeoData)) {
      window.allGeoData = {};
    }

    try {
      if (page) {
        $listContainer.empty();
        if (this.lazyloader) {
          this.lazyloader.destroy();
        }

        this.showLoader({
          id: null,
          url: this.staticPH,
          logTime : this.staticPH,
          referrer : this.staticPH,
          timezone : this.staticPH
        });

        const response = await this.app.apis['mdcdot'].leads.list(this.paginatedUrl.getPageUrl(page), this.sortBy, this.sortByDirection, this.searchParams);
        this.apiResponse = response;
        
        this.paginatedUrl.setPageCount(response.pages);
        this.paginator.setData(response.result);
        this.paginator.setCurrentPage(1);

        geoData = this.paginator.getCurrentPage();
      } else {
        geoData = this.paginator.getNextPage();
      }

      this.removeLoader();

      if (!this.app.isEmpty(geoData)) {
        _.each(geoData, function (row) {
          window.allGeoData[row.id] = row;
          let $row = self.prepareRow(row);
          $row.appendTo($listContainer);
        });

        this.app.initTooltip();

        this.isRendering = false;

        let hasMoreData = this.paginator.hasMoreData();
        return hasMoreData;

      } else if (this.app.isEmpty(window.allGeoData)) {
        let message = 'No Records found';
        let description = 'You have no pixels data';
        if (this.apiResponse.error) {
          message = 'No instance connected';
          description = 'Please select an instance or contact help for support'
        }

        const noRecordsOptions = {
          title: message,
          class: 'available-mdcdot-table-height no-leads',
          description: description,
          help: {
            text: 'Need Help ?',
            onClick: () => {
              console.log('Help clicked');
              // Code to open help documentation or contact support
            }
          }
        };
        const placeholder = new NoRecordsPlaceholder(this.app, this.container.closest('.table-responsive'), noRecordsOptions);
        placeholder.render();
      }

    } catch (error) {
      console.error("Error occurred during operation:", error);
    }
  }
}

(function (aimi_geo, $, app, undefined) {
  $(document).off('click.mdcdot_geo_events').on('click.mdcdot_geo_events', '[data-geo-action]', async function (e) {
    const $this = $(this); // Cache the clicked element
    const action = $this.data('geo-action'); // Extract the action from the data attribute


    switch (action) {
      case 'view':
        const geoId = $this.attr('data-id');
        const geoData = window.allGeoData[geoId];

        const page = _.template(app.templates['dashboard__geo-view']);

        geoData.isReturning  = geoData.isReturning ? 'Yes' : 'No';
        geoData.cookieEnabled  = geoData.cookieEnabled ? 'Yes' : 'No';
        let pageData = {
          ...geoData
        };

        const $modal = app.infoModal(`Visitors Info - ${geoData.site}`, page(pageData), {
          id: 'geoModal',
          dialogClass: 'modal-lg '
        });

        break;

      case 'pixels-view' :
        break;
    }
  })
}(window.aimi_geo = window.aimi_geo || {}, jQuery, PreBuilt));